exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout-heading[data-v-02b88f95]{min-height:400px}", ""]);

// exports
